export function scrollTo() {
  const cta = document.getElementById('js-amply-cta');

  if (cta) {
    const rect = cta.getBoundingClientRect();
    window.scrollTo(0, (window.scrollY + rect.y) - 16 - 53); // - margin - nav
  }
}
